import React from 'react'

const SparkProgress = () => {
	return (
		<div className='converseValues-content'>
			<h1 className='section-title'>SPARK PROGRESS*</h1>

			<div className='ncss-row' style={{ marginTop: '48px', borderBottom: '1px solid white', paddingBottom: '50px' }}>
				<div className='ncss-col-sm-12 ncss-col-md-4 pb4-sm'>
					<p className='section-title' style={{ fontSize: '40px' }}>
						CURIOSITY
					</p>
					<p className='section-p'>
						We indulge our thirst for knowledge. Play. Poke. Question. Dream. That’s how we unearth opportunity and excite
						possibility. Curiosity is the engine of our growth.
					</p>
				</div>
				<div className='ncss-col-sm-12 ncss-col-md-4 pb4-sm'>
					<p className='section-title' style={{ fontSize: '40px' }}>
						OPENNESS
					</p>
					<p className='section-p'>
						We build on ideas, not break them. Instead of ‘why?’ we say ‘why not!’. Youth culture moves fast, we adapt by
						staying open, making transformation our craft. It’s in our DNA.
					</p>
				</div>
				<div className='ncss-col-sm-12 ncss-col-md-4 pb4-sm'>
					<p className='section-title' style={{ fontSize: '40px' }}>
						COURAGE
					</p>
					<p className='section-p'>
						We know nothing remarkable was ever done without risk. Progress doesn’t require perfection, it asks for action.
						Taking initiative moves us boldly forward.
					</p>
				</div>
			</div>
			<div className='converse-behaviros'>
				<p className='section-title' style={{ marginTop: '50px', marginBottom: '24px', fontSize: '40px' }}>
					Behaviors
				</p>

				<div className='ncss-row' style={{ marginTop: '24px' }}>
					<div className='ncss-col-sm-12 ncss-col-md-4 pb4-sm' style={{ verticalAlign: 'top' }}>
						<p className='section-p' style={{ fontSize: '24px' }}>
							I BUILD ON THE GREAT IDEAS OF OTHERS
						</p>
					</div>
					<div className='ncss-col-sm-12 ncss-col-md-4 pb4-sm' style={{ verticalAlign: 'top' }}>
						<p className='section-p' style={{ fontSize: '24px' }}>
							I AM CONSTANTLY CURIOUS
						</p>
					</div>
					<div className='ncss-col-sm-12 ncss-col-md-4 pb4-sm' style={{ verticalAlign: 'top' }}>
						<p className='section-p' style={{ fontSize: '24px' }}>
							I BRING GREAT IDEAS OF MY OWN
						</p>
					</div>
				</div>
			</div>
		</div>
	)
}

export default SparkProgress



// WEBPACK FOOTER //
// ./src/containers/AboutPage/ConverseValues/SparkProgress.js